import { render, staticRenderFns } from "./Expire.vue?vue&type=template&id=7038fccc&scoped=true"
var script = {}
import style0 from "./Expire.vue?vue&type=style&index=0&id=7038fccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038fccc",
  null
  
)

export default component.exports